import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14386e20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "marquee" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: _normalizeClass({ 'set-page': _ctx.isSpace })
    }, " 오토콜에서는 서로의 전화번호가 노출되지 않아요.    상대방과 다시 연결해야할 땐 " + _toDisplayString(_ctx.AutocallNumber) + "로 재연결해보세요. ", 3)
  ]))
}